/**
 * 스킬 패키지의 로컬 경로 조각. CLI `skillPackage.ts`의 `SKILL_PACKAGE_DIR` /
 * `SKILL_ENTRY_FILE`과 같은 문자열이어야 한다. web은 cli를 의존할 수 없어 여기서
 * 중복 정의하고, 저장소 전역 계약 테스트가 양쪽을 고정한다.
 */
export const SKILL_PACKAGE_DIR = 'skills';

export const SKILL_ENTRY_FILE = 'SKILL.md';

export const buildSkillLocalPath = (slug: string): string =>
  `.agentteams/${SKILL_PACKAGE_DIR}/${slug}/${SKILL_ENTRY_FILE}`;
